import { createSSRApp } from 'vue'
import App from './App.vue'
import pinia from './stores'
import asyncError from './networkErr/index.vue'
// #ifdef WEB
import Directive from './utils/directive/index'
// #endif

// #ifdef H5
const queryObj = new URLSearchParams(window.location.search)
if (queryObj.get('lang')) {
  sessionStorage.setItem('lang', queryObj.get('lang')!)
} else if (!sessionStorage.getItem('lang')) {
  sessionStorage.setItem('lang', 'en-us')
}
if (queryObj.get('origin') === 'h5') {
  sessionStorage.setItem('origin', 'h5')
  sessionStorage.setItem('ftype', queryObj.get('ftype') || 'wap')
}
// #endif

export function createApp() {
  const app = createSSRApp(App)
  app.use(pinia)
  app.component('asyncError', asyncError) // 全局注册网络异常页面组件（manifest.json中配置）
  // #ifdef WEB
  app.use(Directive)
  // #endif
  return {
    app,
  }
}
